<template>
  <div v-if="page">
    <page-banner
      :title="page.banner.title"
      :text="page.banner.text"
      :colour="page.banner.colour"
    />
    <page-cards :pages="homePageCards"/>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import PageBanner from '@/components/PageBanner.vue';
  import PageCards from '@/components/PageCards.vue';

  export default {
    components: {
      PageBanner,
      PageCards,
    },
    props: {
      homeSlug: String
    },
    mounted() {
      this.fetchPage('home')
        .then(() => {
          this.fetchHomePageCards()
        });
    },
    methods: {
      ...mapActions(['fetchPage', 'fetchHomePageCards']),
    },
    computed: {
      ...mapState(['homePageCards']),
      page() {
        return this.$store.getters.getPage('home');
      },
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    margin: .8em 0 .5em;
  }
</style>
